export default "__VITE_ASSET__BCKzEFXD__"